import { FileExtension, IFileExtensionContext } from 'tessa/ui/files';
import { Card, CardSection, ICAdESProvider } from 'tessa/cards';
import { MenuAction, showNotEmpty } from 'tessa/ui';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { CdEDSHelper, CustomCertData } from '../Helpers/CdEDSHelper';
import { ChFileCategories } from 'src/pkScripts/Helpers/ChFileCategories';
import { FileContainer, IFile } from 'tessa/files';
import { CdGeneralDocumentationClientHelper } from '../Helpers/Cards/CdGeneralDocumentationClientHelper';
import { CdDocStates } from '../Helpers/CdDocStates';

export class CdSignFileContextMenuFileExtension extends FileExtension {
  public async openingMenu(context: IFileExtensionContext) {
    let card: Card = context.control.model.card;
    let files = context.files;
    if (card.typeId !== CdCardTypes.PkExecutiveDocumentationTypeID &&
        card.typeId !== CdCardTypes.TechnicalDocumentationTypeID) {
      return;
    }

    // Находим индексы действий: подписать, проверить подпись и разделитель
    let signActionIndex, checkActionIndex, separatorActionIndex: number = -1;
    context.actions.forEach(action => {
      if (action.name === 'SignEDS') {
        signActionIndex = context.actions.indexOf(action);
      } else if (action.name === 'CheckEDS') {
        checkActionIndex = context.actions.indexOf(action);
      } else if (action.name === 'Separator' && signActionIndex > separatorActionIndex) {
        separatorActionIndex = context.actions.indexOf(action);
      }
    });

    // В вебе все действия по подписанию скрыты, делаем их видимыми
    if (checkActionIndex && separatorActionIndex) {
      context.actions[checkActionIndex].isCollapsed = false;
      context.actions[separatorActionIndex].isCollapsed = false;
    }

    // Исключаем файлы в 1 и 7 категориях и вид подписания "На бумаге" для ИД
    if (card.typeId === CdCardTypes.PkExecutiveDocumentationTypeID) {
      let exeSect: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
      if (!exeSect) return;
      let signingTypeID: number | null = exeSect.fields.tryGet('SigningTypeID');
      if (!signingTypeID || signingTypeID === 0) return;
      if (files.find(x =>
            x.model.category === null ||            
            x.model.category.id === ChFileCategories.DocumentID.id!.toLowerCase() ||            
            x.model.category.id === ChFileCategories.ElectronicSignatures.id!.toLowerCase()) != null) {
        return;
      }     
    } 

    // Исключаем файлы в 3 категория для ИC
    else if (card.typeId === CdCardTypes.PkExecutiveSchemeTypeID) {     
      if (files.find(x =>
            x.model.category === null || x.model.category.id === ChFileCategories.ImplementingSchemes.id!.toLowerCase()) != null)  
        return;      
    }

    // Исключаем файлы в 7 категории, только для РД, только для состояния "Выдано в производство работ" для ТД
    // Исключаем подписание через контекстное меню для согласуемых файлов ТД (63650)
    else if (card.typeId === CdCardTypes.TechnicalDocumentationTypeID) {
      let pdiSect: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
      if (!pdiSect) return;
      let stateID: number | null = pdiSect.fields.tryGet('StateID');
      if (!stateID || stateID !== CdDocStates.Production.id) return;
      let stageID: number | null = pdiSect.fields.tryGet('StageID');
      if (!stageID || stageID !== 2) return;
      if (files.length !== 1 ||
          files.find(x =>
            x.model.category === null ||
            x.model.category.id === ChFileCategories.ElectronicSignatures.id!.toLowerCase()) != null)
        return;
      if (files[0].model.category === null ||
          files[0].model.category.id !== ChFileCategories.Approval.id)
        return;
      if (files.find(x =>
        x.model.category == null ||
        x.model.category.id == ChFileCategories.Approval.id) != null)
        return;
    }
    
    context.actions[signActionIndex] = new MenuAction(
        'PkSignFile',
        'Подписать усиленной подписью',
        "ta icon-thin-197",
        async () => await this.SignFileAsync(context),
        null,
        false
      );
    
    if (card.typeId == CdCardTypes.PkExecutiveDocumentationTypeID) {
      context.actions.splice(signActionIndex + 1, 0, new MenuAction(
        'PkSignFiles',
        'Подписать все файлы в категории усиленной подписью',
        "ta icon-thin-197",
        async () => await this.SignFileAsync(context, true),
        null,
        false
      ));
    }
  }

  private async SignFileAsync(
    context: IFileExtensionContext,
    signAllFilesInCategory: boolean = false) {

    let card: Card = context.control.model.card;
    let fileContainer: FileContainer = context.control.fileContainer;
    let edsProvider: ICAdESProvider = context.control.model.edsProvider;
    let unsignedFiles: {ID: string, Hash?: string | null}[] = [];

    // список файлов на подписание
    let files: IFile[] = [];
    if (signAllFilesInCategory) {
      files = fileContainer.files
        .filter(x =>
          x.category && context.file.model.category &&
          x.category.id == context.file.model.category.id &&
          !x.name.includes(CdGeneralDocumentationClientHelper.PdfForPrint));
      if (files.length == 0) {
        return;
      }
    } else {
      files.push(context.file.model);
    }

    // для РД сразу выбираем сертификат для заполнения штампа
    let isRD = card.typeId == CdCardTypes.TechnicalDocumentationTypeID;
    let certificate: CustomCertData | null = null;
    if (isRD) {
      let selectedCert = await CdEDSHelper.GetCertificatePlatformAsync(edsProvider);
      if (!selectedCert.Certificate) {
        throw new Error('Не выбран сертификат.');
      }
      certificate = selectedCert.Certificate;
    }
    for (let file of files) {
      let technicalDocumentationResult = await CdGeneralDocumentationClientHelper.TechnicalDocumentationCheckFileAsync(
        card,
        file,
        certificate);
      if (technicalDocumentationResult.Result.items && technicalDocumentationResult.Result.items.length > 0) {
        showNotEmpty(technicalDocumentationResult.Result.build());
        return;
      }

      unsignedFiles.push({ID: file.id, Hash: technicalDocumentationResult.UnsignedHash});
    }

    // прикрепленная подпись
    let isAttachedSignature = await CdGeneralDocumentationClientHelper.CheckIsAttachedSignatureAsync(card, context.control.fileContainer.files);

    // TODO TIV: текущий context не подходит
    //  // DSS подписание (с выходом из метода при успешном подписании)
    //  if (!isAttachedSignature) {
    //   let isDSS = await CdGeneralDocumentationClientHelper.SignFilesByDSSAsync(
    //     context,
    //     userSession.UserID,
    //     null,
    //     files
    //   );

    //   if (isDSS) {
    //     return;
    //   }
    // }
    
    // CAdES подписание
    let edsResult = await CdEDSHelper.SignFilesAsync(
      fileContainer,
      edsProvider,
      card,
      unsignedFiles,
      !isAttachedSignature,
      false,
      certificate
    );

    if (!edsResult.isSuccessful) {
      showNotEmpty(edsResult.build());
      return;
    }

    await context.control.model.saveAsync();
  }
}